import { render, staticRenderFns } from "./THGUserCarsList.vue?vue&type=template&id=4c200eba"
import script from "./THGUserCarsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGUserCarsList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports